var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 26C48 32.4114 45.504 38.4366 40.9714 42.9714L40.7726 43.1429H48V45.4286H36.5714V34H38.8571V41.7829L39.4149 41.2983C43.456 37.2549 45.7143 31.8011 45.7143 26C45.7143 20.1989 43.456 14.7451 39.3554 10.6446C35.2526 6.544 29.7989 4.28571 24 4.28571H22.8571V2H24C30.4091 2 36.4366 4.496 40.9714 9.02857C45.504 13.5634 48 19.5886 48 26ZM2.28571 23.7143C2.28571 29.5154 4.544 34.9691 8.64457 39.0697C12.7474 43.1703 18.2011 45.4286 24 45.4286H25.1429V47.7143H24C17.5909 47.7143 11.5634 45.2183 7.02857 40.6857C2.496 36.1509 0 30.1257 0 23.7143C0 17.3029 2.496 11.2777 7.02857 6.74286L7.22743 6.57143H0V4.28571H11.4286V15.7143H9.14286V7.93143L8.58514 8.416C4.544 12.4594 2.28571 17.9131 2.28571 23.7143Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.ec344c9351475ef40c8e7fefa30191f8.svg";
export { ForwardRef as ReactComponent };